export const sortingTypes = {
  BY_NEWEST_FIRST: "newest",
  BY_OLDEST_FIRST: "oldest",
  BY_GRID_CODE: "gridcode",
};
